import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    addNewRowToTable,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {AppVersionService} from "../../serverService/appVersionService/AppVersionService";
import AddNewAppVersion from "./addNewAppVersion/AddNewAppVersion";
import {useNavigate} from "react-router-dom";
import {handleAddNewItem} from "../../raikoComponents/raikoEditor/RaikoCustomEditor2";

export default function AppVersionList() {

    let page = 0;
    const size = 15;

    const service = new AppVersionService()

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [appVersionsList, setAppVersionsList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getAppVersionListFromServer()
        }
    }, []);


    function generateAppVersionRow(number, id, title, versionNumber, minimumVersion, enabled, mandatory, storePublished) {
        return ({
            number,
            id,
            title,
            versionNumber,
            minimumVersion,
            enabled: <RaikoCustomSimpleActiveDeActiveChip
                state={enabled}
                activeStateTitle={"منتشر شده"}
                deActiveStateTitle={"پیش نویس"}
            />,
            mandatory: <RaikoCustomSimpleActiveDeActiveChip
                state={!mandatory}
                activeStateTitle={"اختیاری"}
                deActiveStateTitle={"اجباری"}
            />,
            storePublished: <RaikoCustomSimpleActiveDeActiveChip
                state={storePublished}
                activeStateTitle={"منتشر شده"}
                deActiveStateTitle={"منتشر نشده"}/>,

        })
    }

    function getAppVersionListFromServer() {
        setTableLoading(true)
        service.getAppVersionList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setAppVersionsList([])
                response.data.map((item, index) => {
                    setAppVersionsList(prevState => [
                        ...prevState,
                        generateAppVersionRow(
                            (page * size) + index + 1,
                            item.id,
                            item.name,
                            item.versionNumber,
                            item.latestValidVersionNumber,
                            item.enabled,
                            item.mandatory,
                            item.storePublished,
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleChangePage(newPage) {
        page = newPage
        getAppVersionListFromServer()
    }

    const [appVersionInfoDialogOpenState, setAppVersionInfoDialogOpenState] = useState(false);

    function handleOpenAddNewAppVersionDialog() {
        setAppVersionInfoDialogOpenState(true)
    }

    function handleCloseDialog() {
        setAppVersionInfoDialogOpenState(false)
    }

    const navigate = useNavigate()

    function handleShowVersionDetails(id) {
        let _title = ""
        appVersionsList.map((item) => {
            if (item.id === id)
                _title = item.title
        })
        navigate(RouteHelper.AppVersionDetail.globalUrl.replace(":id", id),
            {state: {title: _title}, replace: false}
        )
    }

    function handleAddNewVersionAppToTable(appItem) {
        handleCloseDialog()
        const _appItems = addNewRowToTable(generateAppVersionRow(
            1,
            appItem.id,
            appItem.name,
            appItem.versionNumber,
            appItem.latestValidVersionNumber,
            appItem.enabled,
            appItem.mandatory,
            appItem.storePublished,
        ), appVersionsList)
        setAppVersionsList(_appItems)
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.AppVersionList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={appVersionInfoDialogOpenState}
                hasCloseButton={false}
            >
                <AddNewAppVersion
                    handleCloseDialog={handleCloseDialog}
                    handleAddNewVersionApp={handleAddNewVersionAppToTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.Android.name, ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.AppVersionList.name, ""),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"نسخه ها"}
                                amount={numberOfItems}
                                hasCreateNewItem
                                handleCreateNewItem={handleOpenAddNewAppVersionDialog}
                            />
                            <RaikoCustomTable
                                header={appVersionTableHeader}
                                data={appVersionsList}
                                isLoading={tableLoading}
                                handlePaginationChange={handleChangePage}
                                pageCount={pageCount}
                                rowClicked={handleShowVersionDetails}
                            />
                        </RaikoGridOneColumn>

                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}
const appVersionTableHeader = [
    {id: 'number', label: '#'},
    {id: 'title', label: 'عنوان'},
    {id: 'versionNumber', label: 'ورژن'},
    {id: 'minimumVersion', label: 'حداقل ورژن مجاز'},
    {id: 'enabled', label: 'وضعیت'},
    {id: 'mandatory', label: 'اجباری'},
    {id: 'storePublished', label: 'کافه بازار'},
]